import { vec3, vec4 } from "gl-matrix";
import { Context } from "../Engine";
import { Camera } from "../View/Camera";
import { TextManager } from "./TextManager";
import { IDrawableObject, ObjectInteraction, RenderSettings } from "../Object/ObjectManager";
import { PropertyAnimation } from "@spi/Common/Animation";

export abstract class TextElement implements IDrawableObject {
    public order = 99999;
    animatedProperties: PropertyAnimation;
    interaction: ObjectInteraction;

    protected _text: string;
    protected _position: vec3;

    public offset: vec3;

    private positionLink: PositionLink;

    constructor(public textManager: TextManager, public inWorldSpace: boolean = true, public centerText: boolean = true) {
        this.positionLink = null;
        this._position = vec3.fromValues(0, 0, 0);
        this.offset = vec3.fromValues(0, 0, 0);
    }

    public set position(pos: vec3) {
        this._position = pos;
        this.positionLink = null;
    }

    public get position(): vec3 {
        if (this._position) {
            return this._position;
        } else {
            let pos = this.positionLink.position;

            return vec3.fromValues(pos[0], pos[1], pos[2]);
        }
    }

    public linkPosition(obj: PositionLink) {
        this.positionLink = obj;
        this._position = null;
    }

    public get text() {
        return this._text;
    }

    public set text(str: string) {
        this._text = str;
    }
    
    public abstract render(ctx: Context, camera: Camera, settings: RenderSettings): void;

    public abstract destroy(): void;
}

type PositionLink = {
    position: vec3 | vec4
}